import { useQuery } from "@tanstack/react-query";
import { GetProjectsForSidebarResponse } from "tng-address-collection-shared/types/apiTypes.ts";
import { useAuthentication } from "../auth/useAuthentication.ts";
import { NonRetryableError } from "../errors/nonRetryableError.ts";
import { queryKeys } from "./queryKeys.ts";

export const useGetProjects = () => {
  const { getToken, isAuthenticated } = useAuthentication();

  return useQuery({
    queryKey: queryKeys.projects(),
    queryFn: async ({ signal }): Promise<GetProjectsForSidebarResponse> => {
      const token = await getToken();
      const response = await fetch(`/api/projects`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        signal,
      });

      if (response.ok) {
        return GetProjectsForSidebarResponse.parse(await response.json());
      }

      if (response.status === 403) {
        throw new NonRetryableError("No permission to load the projects");
      }

      throw new Error(`Loading the projects failed: ${response.status}`);
    },
    retry: (failureCount, error) =>
      !(error instanceof NonRetryableError) && failureCount < 3,
    enabled: isAuthenticated,
    placeholderData: [],
    staleTime: Infinity,
    gcTime: Infinity,
  });
};
